module.exports = __webpack_public_path__ + "static/img/banco-do-brasil.ad64006b.svg";